import React, { useMemo } from 'react'

import st from './index.scss'

function Line({ children, type = 'normal', index }) {
    const index_type = {
        normal: new Array(20).fill(0).map((i, idx) => `${idx + 1}、`),
        circle: [
            '①',
            '②',
            '③',
            '④',
            '⑤',
            '⑥',
            '⑦',
            '⑧',
            '⑨',
            '⑩',
            '⑪',
            '⑫',
            '⑬',
            '⑭',
            '⑮',
            '⑯',
            '⑰',
            '⑱',
            '⑲',
            '⑳'
        ].map((item) => `${item} `)
    }

    const inner_type = useMemo(() => {
        const keys = Object.keys(index_type)
        if (keys.indexOf(type) !== -1) {
            return type
        }

        return 'normal'
    })
    const inner_index = useMemo(() => (index > 20 ? 20 : index), [index])

    return (
        <div className={st['line']}>
            <div className={st[`__${inner_type}`]}>
                {index_type[inner_type][inner_index]}
            </div>
            <div>{children}</div>
        </div>
    )
}

export default function Rules({ data, ...props }) {
    return (
        <div {...props}>
            {data.map((item, idx) => {
                if (typeof item === 'string') {
                    return (
                        <Line key={idx} index={idx}>
                            {item}
                        </Line>
                    )
                }
                return (
                    <Line key={idx} index={idx}>
                        <div>{item.title}</div>
                        <div>
                            {item.children.map((chi, idx) => {
                                return (
                                    <Line key={idx} index={idx} type="circle">
                                        {chi}
                                    </Line>
                                )
                            })}
                        </div>
                    </Line>
                )
            })}
        </div>
    )
}
